define([
	"dojo/_base/declare",
	"csi/xml",
	"csi/xml/Query",
	"WBS/DeliverablesReportTable",
	"WBS/ReportTableMixin"
], function(declare,xml,Query,DeliverablesReportTable,ReportTableMixin) {

	return declare([ DeliverablesReportTable, ReportTableMixin ], {
		_resolveView: function() {
			// summary: show just elements that are below us in the hierarchy
			this.relRoot.addQuery(new Query()
				.RefAttr(this.getViewNodeReferenceAttrName(), xml.OP_EQUALS, this.getViewURL(), "Child:WBS/Child:__Parent__")
				.Access(xml.RIGHT_READ, "Child:WBS/Child:__Parent__")
			);

			this.inherited(arguments);
		}
	});
});
